// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ttbFloorPlanLegendButton {
  position: absolute;
  top: 20px;
  right: 10px;
  z-index: 2;
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--color-wood-600);
  border-radius: 50%;
  background: rgba(245, 239, 231, 0.95);
  color: var(--color-wood-700);
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 800;
  font-style: italic;
  line-height: 1;
  cursor: pointer;
}

.ttbFloorPlanLegendButton:hover {
  border-color: var(--color-fire-600);
  color: var(--color-fire-600);
}

.ttbFloorPlanLegend {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  width: 420px;
  color: var(--color-wood-700);
}

.ttbFloorPlanLegendCross {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--color-wood-700);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.ttbFloorPlanLegendCross:hover {
  color: var(--color-fire-600);
}

.ttbFloorPlanLegend .tavern-modal-title {
  margin: 0;
}

.ttbFloorPlanLegendGroupTitle {
  margin-bottom: var(--space-2);
  font-size: 12px;
  font-weight: 700;
  opacity: 0.85;
}

.ttbFloorPlanLegendList {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.ttbFloorPlanLegendItem {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: 13px;
}

.ttbFloorPlanLegendTable {
  flex: none;
}

.ttbFloorPlanLegendFraction {
  flex: none;
  min-width: 28px;
  font-size: 16px;
  font-weight: 800;
}

.ttbFloorPlanLegendNote {
  margin: var(--space-2) 0 0;
  font-size: 12px;
  opacity: 0.85;
}

.ttbFloorPlanLegendClose {
  padding: 8px 20px;
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-md);
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/features/floorPlan/FloorPlanLegend.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".ttbFloorPlanLegendButton {\n  position: absolute;\n  top: 20px;\n  right: 10px;\n  z-index: 2;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--color-wood-600);\n  border-radius: 50%;\n  background: rgba(245, 239, 231, 0.95);\n  color: var(--color-wood-700);\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 800;\n  font-style: italic;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.ttbFloorPlanLegendButton:hover {\n  border-color: var(--color-fire-600);\n  color: var(--color-fire-600);\n}\n\n.ttbFloorPlanLegend {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  width: 420px;\n  color: var(--color-wood-700);\n}\n\n.ttbFloorPlanLegendCross {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--color-wood-700);\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.ttbFloorPlanLegendCross:hover {\n  color: var(--color-fire-600);\n}\n\n.ttbFloorPlanLegend .tavern-modal-title {\n  margin: 0;\n}\n\n.ttbFloorPlanLegendGroupTitle {\n  margin-bottom: var(--space-2);\n  font-size: 12px;\n  font-weight: 700;\n  opacity: 0.85;\n}\n\n.ttbFloorPlanLegendList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ttbFloorPlanLegendItem {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: 13px;\n}\n\n.ttbFloorPlanLegendTable {\n  flex: none;\n}\n\n.ttbFloorPlanLegendFraction {\n  flex: none;\n  min-width: 28px;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.ttbFloorPlanLegendNote {\n  margin: var(--space-2) 0 0;\n  font-size: 12px;\n  opacity: 0.85;\n}\n\n.ttbFloorPlanLegendClose {\n  padding: 8px 20px;\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-md);\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
